import FirebaseContext,{ withFirebase } from './Context';
import Firebase from './firebase';
 
export default Firebase;
 
export { FirebaseContext,withFirebase };